// Export a variable holding the value of the API URL.
export const API_URL = process.env.REACT_APP_API_URL;